import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import projects from '../data/projects';
import { waLink } from '../data/content';
import ProjectCard from './ProjectCard';
const { FiArrowUpRight } = FiIcons;
function Projects() {
  return (
    <section className="pad" id="work" style={{ background: 'var(--bg-2)' }}>
      <div className="wrap">
        <div className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', maxWidth: 'none' }}>
          <div>
            <span className="eyebrow">Selected work</span>
            <h2 className="h-section">Projects I'm proud of</h2>
            <p>Hover any project to scroll through the full-page screenshot. Click to enquire on WhatsApp.</p>
          </div>
          <a className="link-arrow" href={waLink} target="_blank" rel="noreferrer" style={{ display: 'none' }}>See all <SafeIcon icon={FiArrowUpRight} /></a>
        </div>
        <div className="proj-grid">
          {projects.map((p, i) => <ProjectCard key={p.name} project={p} index={i} />)}
        </div>
        <div style={{ textAlign: 'center', marginTop: 44 }}>
          <a className="btn btn-whatsapp" href={waLink} target="_blank" rel="noreferrer">
            Start your project on WhatsApp <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
      </div>
    </section>
  );
}
export default Projects;
